module.exports = __webpack_public_path__ + "static/media/School-management2.58a01c03.PNG";